import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {SenatorTrades} from '../../../../../api/models/senator-trades';
import {SenatorTransactionTypes} from '../../../../../api/models/senator-transaction-types';
import {SenatorAssetType} from '../../../../../api/models/senator-asset-type';
import {SenatorAmountRanges} from '../../../../../api/models/senator-amount-ranges';
import {SenatorOwnerTypes} from '../../../../../api/models/senator-owner-types';
import {ConfirmationService, Message} from 'primeng/api';
import {SenatorService} from '../../../../../api/services/senator.service';
import {CongressType} from '../../../../../api/models/congress-type';

@Component({
  selector: 'app-show-trade-by-id',
  templateUrl: './show-trade-by-id.component.html',
  styleUrls: ['./show-trade-by-id.component.scss'],
  providers: [ConfirmationService]
})
export class ShowTradeByIdComponent implements OnInit {
  showDialog = false;
  trade = {} as SenatorTrades;
  title = 'Trade Detail';
  toastMsgs = [] as Message[];

  transactionTypes = SenatorTransactionTypes.values();
  assetTypes = SenatorAssetType.values();
  amongRanges = SenatorAmountRanges.values();
  ownerTypes = SenatorOwnerTypes.values();
  @Output() closeClicked = new EventEmitter();
  private type = '';

  constructor(private senatorService: SenatorService, private confirmationService: ConfirmationService) {
  }

  ngOnInit() {
  }

  close() {
    const form = {} as any;
    this.hide(form);
  }

  private closeOnly(form) {
    form.reset();
    this.trade = {} as SenatorTrades;
    this.showDialog = false;
    this.closeClicked.emit();
  }

  private showMessage(msg, type) {
    this.toastMsgs = [];
    this.toastMsgs.push({severity: type, summary: 'Message', detail: msg});
  }

  private saveAndClose(form) {
    if (form.invalid) {
      this.showMessage('Invalid input makes it unable to save', 'error');
      return;
    }
  }

  private hide(form) {
    if (!form.dirty) {
      this.closeOnly(form);
      return;
    }
    this.confirmationService.confirm(
      {
        message: 'Do you want to save this?',
        key: 'approvePopup',
        accept: () => {
          this.saveAndClose(form);
        },
        reject: () => {
          this.closeOnly(form);
        }
      }
    );
  }

  loadDialog(trade_id: number, type: string) {
    this.type = type;
    let res = null as SenatorTrades;
    const theType = CongressType.values().find(t => t.toString() == type);
    this.senatorService.getSenatorTradeByTradeId({congressType: theType, tradeId: trade_id})
      .subscribe(value => {
          res = value;
        }, (error) => {
          this.showMessage(error.error.messaage, 'error');
        },
        () => {
          if (res != null) {
            this.showDialog = true;
            this.trade = res;
          } else {
            this.showMessage('Trade doesn\'t found', 'warn');
          }
        });
  }

  loadAssetSearch() {

  }
}
